<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-point">
      <Title :jpn="t('ポイント購入')" />
      <!-- <div class="carrer_memo">
        If you would like to pay with "carrier billing, Merpay, LINEPay, PayPay", you can also purchase at <a href="https://www.iranoan.com/blank-3/Point-for-Get24" target="_blank">minny online store!</a><br>
        If you would like your points to be reflected immediately, please select payment by credit card. Other payment methods may take longer.</div> -->
      <div class="point_course_area">
        <!-- <div class="rate">*FX rate : as of {{rateDate}}</div> -->
        <div class="gem_images">
          <PointCourse
            v-for="(pointPriceItem) in pointPriceList" :key="pointPriceItem.id"
            class="point-course"
            :currentUser="currentUserDetail"
            :pointPriceItem="pointPriceItem"
            @handleBuyBtnClick="buyPoint(pointPriceItem.id)"
          />
        </div>
      </div>
      <!-- <MypageButton
        class="get_coin"
        :text="t('動画を見てコインを獲得')"
        @handleSquareBtnClick="goToGetCoin"
      /> -->
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import PointCourse from '@/components/organisms/PointCourse.vue';
import Title from '@/components/molecules/Title02.vue';
// import MypageButton from '@/components/atoms/MypageButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'BuyPoint',
  mixins: [t],

  components: {
    BaseTemplate,
    PointCourse,
    Title,
    // MypageButton,
  },

  data: () => ({
    rateDate: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      pointPriceList: 'pointPrice/pointPriceList',
      resultCouponPointPresent: 'coupon/resultCouponPointPresent',
    }),
  },

  watch: {
    pointPriceList(newVal) {
      if (newVal) {
        let baseDate = new Date('2000-01-01 00:00:00');
        for (let i = 0; i < newVal.length; i += 1) {
          const date = new Date(newVal[i].modified);
          if (baseDate < date) {
            baseDate = date;
          }
        }
        this.rateDate = `${baseDate.getMonth() + 1}/${baseDate.getDate()}/${baseDate.getFullYear()}`;
      }
    },
    resultCouponPointPresent(newVal) {
      if (newVal.status !== 200) {
        alert('Failed to grant Gems. Please contact the management.');
      } else {
        const query = { append: true };
        this.$router.push({ path: '/complete-buy-point', query });
      }
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('pointPrice/setPointPriceList', { pageNumber });
  },

  methods: {
    buyPoint(pointPriceId) {
      const query = {
        pointPriceId,
      };
      let isPresent = false;
      this.pointPriceList.forEach((pointPriceItem) => {
        if (pointPriceItem.id === pointPriceId) {
          if (pointPriceItem.rate === '100') {
            isPresent = true;
          }
        }
      });
      if (isPresent) {
        if (window.confirm('I will purchase the Gems, if that\'s OK?')) {
          this.$store.dispatch('coupon/pointPresent', { pointPriceId });
        }
        return;
      }
      this.$router.push({ path: '/confirm-buy-point', query });
    },
    goToGetCoin() {
      this.$router.push('/watch-videos');
    },
  },
};
</script>

<style lang="scss" scoped>
.carrer_memo {
  margin-top: 10px;
  color: $white;
  font-size: 80%;
  a {
    color: $white!important;
  }
}
.buy-point{
  width: 100%;
  max-width: 900px;
  min-height: 100%;
  padding: 30px 10px 33px 10px;
  margin: 0 auto;
  // @include appendMap($backgroundStyleMap);
  .point_course_area {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .gray_area {
      width: 100%;
      margin: 5px 0;
      padding: 0;
    }
    .rate {
      text-align: right;
      color: $white;
      margin-bottom: 20px;
    }
  }
  .gem_images {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
  }
}
.get_coin {
  width: 100%;
  font-size: 30px;
  padding: 10x 0;
  margin-top: 15px;
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_area {
    flex-direction: column;
  }
  .buy-point {
    padding: 30px 20px;
  }
  .shadow-button {
    font-size: 16px;
  }
  .get_coin {
    font-size: 20px;
  }
}
</style>
